import { createFeatureSelector, createSelector } from '@ngrx/store';
import { OIDC_SIGNUP_FEATURE_KEY, OidcSignupState } from './oidc-signup.reducer';

export const getOidcSignupState = createFeatureSelector<OidcSignupState>(OIDC_SIGNUP_FEATURE_KEY);
export const getOidcSignupLoading = createSelector(getOidcSignupState, (state: OidcSignupState) => state.loading);
export const getOidcSignupDone = createSelector(getOidcSignupState, (state: OidcSignupState) => state.done);
export const getOidcSignupError = createSelector(getOidcSignupState, (state: OidcSignupState) => state.error);
